module.exports = __webpack_public_path__ + "img/success.674998c1.svg";